function getPublishDestinationUrl(siteUrl, pageName) {
    const rawSiteUrl = String(siteUrl || '').trim();
    if (!rawSiteUrl) return '';

    const normalizedSiteUrl = /^https?:\/\//i.test(rawSiteUrl)
        ? rawSiteUrl
        : `https://${rawSiteUrl}`;

    try {
        const url = new URL(normalizedSiteUrl);
        const normalizedPageName = String(pageName || '')
            .trim()
            .replace(/^\/+|\/+$/g, '');

        url.pathname =
            !normalizedPageName || normalizedPageName === 'index'
                ? '/'
                : `/${normalizedPageName}`;
        url.search = '';
        url.hash = '';

        return url.toString();
    } catch {
        return normalizedSiteUrl;
    }
}

module.exports = { getPublishDestinationUrl };
